import { toggle } from 'slide-element';

export function initAccordionAction(context, once) {
  once('accordionAction', '.accordion-item', context).forEach(item => {
    item.querySelector('.accordion-title').addEventListener('click', e => {
      toggle(item.querySelector('.accordion-body'), {
        duration: 300,
        easing: 'ease-in-out'
      });
      item.querySelector('.chevron-icon').classList.toggle('-scale-y-100');
    });
  });
}
